export default "__VITE_ASSET__BG3r3Z_j__"